import { useState } from "react";
import { UsersPage } from "./UsersPage";
import { RolesPage } from "./RolesPage";
import { AgentsPage } from "./AgentsPage";

type Tab = "users" | "roles" | "agents";

export function AccountPage() {
  const [tab, setTab] = useState<Tab>("users");

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h2 className="text-lg font-semibold">Account management</h2>
        <div className="inline-flex rounded-lg border border-slate-200 bg-slate-50 p-0.5 text-sm">
          <SegBtn active={tab === "users"} onClick={() => setTab("users")}>
            Users
          </SegBtn>
          <SegBtn active={tab === "roles"} onClick={() => setTab("roles")}>
            Roles
          </SegBtn>
          <SegBtn active={tab === "agents"} onClick={() => setTab("agents")}>
            Agents
          </SegBtn>
        </div>
      </div>

      {tab === "users" && <UsersPage />}
      {tab === "roles" && <RolesPage />}
      {tab === "agents" && <AgentsPage />}
    </div>
  );
}

function SegBtn({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1 rounded-md font-medium transition-colors ${
        active ? "bg-white text-slate-900 shadow-sm border border-slate-200" : "text-slate-500 hover:text-slate-800"
      }`}
    >
      {children}
    </button>
  );
}
